import React from 'react';
import Banner from "./components/Banner";
import Fetch from "./components/Fetch";

const App = () => {
  
  return (
    <>
    <Banner />
    <Fetch />
    </>
 
  )
}

export default App
